/**
 *  OTHER PAGES - TRANSVERSE
 *
 *  - Hub Sports
 *  - Sportspage
 *  - Question & Answer
 *  - Workshop
 *
 */

// Hub Sports
if ($('#container-floor-hs-categories').length)
  require('./hub/hub-sports').init();


//htc
if ($('.cube-htc').length)
  require('./htc/htc').init();



// WEBPACK FOOTER //
// ./src/modules-es5/pages/index.js